import { render } from "./PatientFiles.vue?vue&type=template&id=e3c90e1e"
import script from "./PatientFiles.vue?vue&type=script&lang=js"
export * from "./PatientFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__